var React = require('react');

function X (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"18","y1":"6","x2":"6","y2":"18","key":0}),React.createElement("line",{"x1":"6","y1":"6","x2":"18","y2":"18","key":1})]);
}

X.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-x"};

module.exports = X;

X.default = X;
